import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import Modal from './../../modal';
import { ExtendForm } from '../../forms';
import { Snackbar } from '../../snackbar';
import { getFullName } from '../../../utilities/string';
import { updateClientWorker } from '../../../reducers/clients';
import { dateToFloatingString } from '../../../utilities/dateTime';
import { getJobProjects } from '../../../reducers/timekeeping';

class ExtendButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            worker: undefined
        };

        // modal controls
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        const { getJobProjects, worker } = this.props;
        getJobProjects(worker.id);
    }

    onOpen() {
        const { worker } = this.props;
        this.setState({ modal: true, worker: { ...worker } });
    }

    onClose() {
        this.setState({ modal: false, worker: undefined });
    }

    onSubmit(values) {
        const { updateClientWorker, worker, onSuccess, users } = this.props;
        const projects = values.projects.map(p => ({
            project_id: p.project_id,
            rate: worker.pay_type === 'h' ? p.rate : undefined,
            project_value: worker.pay_type === 's' ? p.project_value : undefined,
            rate_currency: 'USD',
            hours_per_week: worker.pay_type === 'h' ? p.hours_per_week : undefined
        }));

        const job = {
            id: values.id,
            title: values.title,
            start_date: dateToFloatingString(values.start_date),
            projects,
            hm_id: values.hm_id,
            end_date: values.end_date ? dateToFloatingString(values.end_date, 'YYYY-MM-DD') : null,
            po_when: values.po_number ? 'now' : worker.po_when === 'now' ? 'later' : worker.po_when,
            po_number: values.po_number || null,
            po_value: values.po_value || null
        };

        updateClientWorker(job, () => {
            this.onClose();
            Snackbar.success(<FormattedMessage {...messages.updateSuccess} values={{ name: getFullName(worker.user) }} />);
            onSuccess(users.find(u => u.id === values.hm_id) || {});
        });
    }

    render() {
        const { modal, worker } = this.state;
        const { button, users, projects, projectsOptions, clientId, inviteUser, message, isExtend } = this.props;

        let buttonComponent = button ? (
            button
        ) : (
            <span className="button extendButton" onClick={this.onOpen}>
                {' '}
                <FormattedMessage {...message || messages.extend} />
            </span>
        );

        return (
            <React.Fragment>
                {buttonComponent}
                <Modal
                    open={modal}
                    onClose={this.onClose}
                    managedClose
                    size="col-sm-10 col-sm-offset-1 col-xs-12 extend-modal"
                    title={<FormattedMessage {...(isExtend ? messages.extendWorkersContract : messages.editWorkersContract)} />}
                >
                    <ExtendForm
                        worker={worker}
                        onSubmit={this.onSubmit}
                        cancel={this.onClose}
                        initialValues={{ ...worker, projects: (projects || []).map(p => p.job_project) }}
                        users={users}
                        projectsOptions={projectsOptions}
                        clientId={clientId}
                        inviteUser={inviteUser}
                    />
                </Modal>
            </React.Fragment>
        );
    }
}

ExtendButton.defaultProps = {
    button: undefined,
    onSuccess: () => {}
};
ExtendButton.propTypes = {
    button: PropTypes.any,
    onSuccess: PropTypes.func
};

const mapStateToProps = state => {
    return {
        projects: state.timekeeping.projects
    };
};
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getJobProjects,
            updateClientWorker
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ExtendButton);



// WEBPACK FOOTER //
// ./src/components/richButtons/extendButton/index.jsx